import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router'
import { loginHref } from '../lib/analytics'
import { Card, EmptyState, Skeleton } from '../ui'
import { useSession } from '../lib/session'

/** Renders children for signed-in users; a sign-in prompt otherwise. */
export function RequireAuth({ children, what = 'this page' }: { children: ReactNode; what?: string }) {
  const { me } = useSession()
  const location = useLocation()
  if (me === undefined) return <div style={{ padding: 24 }}><Skeleton lines={4} label="Checking your session" /></div>
  if (me === null) {
    return (
      <div style={{ padding: 24, maxWidth: 560, margin: '0 auto', width: '100%' }}>
        <Card>
          <EmptyState title={`Sign in to see ${what}`} action={<Link to={loginHref(location.pathname + location.search)}>Sign in or create a free account</Link>}>
            It takes one email code — no password.
          </EmptyState>
        </Card>
      </div>
    )
  }
  return <>{children}</>
}
